<!--begin::Container-->
<div>
  <!--begin::Profile Personal Information-->
  <div class="d-flex flex-row">
    <!--begin::Aside-->
    <div
      class="flex-row-auto offcanvas-mobile w-250px w-xxl-300px"
      id="kt_profile_aside"
      *ngIf="drug?.id"
    >
      <!--begin::Profile Card-->
      <div class="card card-custom card-stretch">
        <!--begin::Body-->
        <div class="card-body pt-4">
          <!--begin::User-->
          <div
            class="d-flex align-items-center"
            style="margin-bottom: 20px; justify-content: center"
          >
            <span class="symbol symbol-70 symbol-xxl-100 align-self-start align-self-xxl-center">
              <span>
                <div>
                  <div class="image-input image-input-outline image-input-changed">
                    <img
                      class="image-input-wrapper"
                      src="{{ drugProfile }}"
                      style="width: 150px; height: 150px"
                      alt="Drug Profile"
                    />
                    <label
                      *ngIf="!isViewMode"
                      class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow dropdown-toggle dropdown-toggle-split"
                      data-action="change"
                      data-toggle="dropdown"
                      title=""
                      data-original-title="Change avatar"
                    >
                      <i class="fa fa-pen icon-sm text-muted"></i>
                    </label>
                    <label
                      *ngIf="drug.pre_signed_url?.url"
                      class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow magnify-icon"
                      data-action="zoom"
                      (click)="showDrugPhoto(drug)"
                      matTooltip="Zoom in"
                      style="position: absolute; bottom: -11px; right: -8px"
                    >
                      <i class="flaticon-search-magnifier-interface-symbol icon-nm text-muted"></i>
                    </label>
                    <div class="dropdown-menu dropdown-menu-sm dropdown-menu-left">
                      <a class="dropdown-item" (click)="updateProfile()"> Upload photo </a>
                    </div>
                  </div>
                </div>
              </span>
            </span>
          </div>
          <!--end::User-->
          <div>
            <div>
              <div
                style="max-width: 240px; overflow: hidden; margin: auto; text-align: center"
                class="main-cont"
              >
                <p class="font-weight-bolder text-dark-75 mb-0 name-div">{{ drug?.drug }}</p>
                <p class="text-primary mb-0">{{ drug ? drug.brand : '' }}</p>
              </div>
            </div>
          </div>
          <!--end::User-->

          <!--begin::Contact-->
          <div class="py-9">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">NDC:</span>
              <a class="text-muted">{{ drug?.ndc ? this.drug.ndc : '' }}</a>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">Generic Name:</span>
              <a class="text-muted">{{ drug?.generic ? this.drug.generic : '' }}</a>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">Manufacturer:</span>
              <span class="text-muted">{{ drug?.manufacturer ? this.drug.manufacturer : '' }}</span>
            </div>
          </div>
          <!--end::Contact-->
        </div>
        <!--end::Body-->
      </div>
      <!--end::Profile Card-->
    </div>
    <!--end::Aside-->
    <!--begin::Content-->
    <div
      class="flex-row-fluid"
      [ngStyle]="drug?.id ? { 'margin-left': '8px' } : { 'margin-left': '0' }"
    >
      <!--begin::Card-->
      <div class="card card-custom card-stretch">
        <!--begin::Header-->
        <div class="card-header py-3">
          <div class="card-title align-items-start flex-column">
            <h3 class="card-label font-weight-bolder text-dark">
              {{ drug?.id ? drug?.drug + '’s Drug Information' : 'New Drug' }}
            </h3>
            <span class="text-muted font-weight-bold font-size-sm mt-1"
              >{{ drug?.id ? 'Update ' : 'Add ' }} drug Information</span
            >
          </div>
          <div class="card-toolbar">
            <a
              ktBackButton
              class="btn btn-secondary mr-2"
              mat-raised-button
              matTooltip="Back to the drugs list"
            >
              <i class="la la-arrow-left"></i>
              <span class="hidden-mobile" translate="GLOBAL.BACK">Back</span>
            </a>
            <ng-template ngxPermissionsOnly="canEditDrug">
              <a
                *ngIf="isViewMode"
                (click)="editDrug(drug.id)"
                class="btn btn-secondary mr-2"
                mat-raised-button
                matTooltip="Back to the drugs list"
              >
                <span class="hidden-mobile" translate="GLOBAL.EDIT">Edit</span>
              </a>
            </ng-template>
            <a
              *ngIf="!isViewMode && drug && !drug.id"
              href="javascript:;"
              class="btn btn-secondary mr-2"
              (click)="reset()"
              mat-raised-button
              matTooltip="Reset changes"
            >
              <i class="la la-cog"></i>
              <span class="hidden-mobile" translate="GLOBAL.RESET">Reset</span>
            </a>
            <a
              *ngIf="!isViewMode"
              href="javascript:;"
              class="btn btn-primary mr-2"
              color="primary"
              (click)="submit()"
              mat-raised-button
              matTooltip="Save & Continue"
            >
              <span class="hidden-mobile" translate="GLOBAL.SAVE">Save</span>
            </a>
          </div>
        </div>
        <!--end::Header-->

        <!--begin::Form-->
        <form class="form" *ngIf="loadingData">
          <!--begin::Body-->
          <kt-alert
            *ngIf="hasFormErrors"
            type="warn"
            [showCloseButton]="true"
            [duration]="10000"
            (closeAl)="onAlertClose()"
          >
            <span translate="GLOBAL.FORM_ERROR"
              >Oh snap! Change a few things up and try submitting again.</span
            >
          </kt-alert>
          <kt-alert
            *ngIf="emptyDrugGroup"
            type="warn"
            [showCloseButton]="true"
            [duration]="5000"
            (closeAl)="onAlertClose()"
          >
            <span>Please fill the required fields, So you can change the drug picture</span>
          </kt-alert>
          <div class="card-body">
            <div class="row">
              <h5 class="font-weight-bold mb-6">Drug Details</h5>
            </div>

            <div class="form-group row" [formGroup]="drugForm">
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.DRUG">Drug</mat-label>
                  <input matInput formControlName="drug" required />
                  <mat-error *ngIf="isControlHasError('drug', 'required')">
                    Drug is
                    <strong>required</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.BRAND">Brand</mat-label>
                  <input matInput formControlName="brand" />
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <div class="mat-form-field-fluid">
                  <mat-label class="row ml-1">Brand</mat-label>
                  <mat-slide-toggle
                    class="mr-2"
                    formControlName="brand_generic_flag"
                  ></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>Generic</strong>
                  </mat-hint>
                </div>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <div class="mat-form-field-fluid">
                  <mat-label class="row ml-1">Brand</mat-label>
                  <mat-slide-toggle class="mr-2" formControlName="otc_flag"></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>OTC</strong>
                  </mat-hint>
                </div>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.STRENGTH">Strength</mat-label>
                  <input matInput formControlName="strength" />
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.FORM">Form</mat-label>
                  <input matInput formControlName="form" />
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.UNIT">Unit</mat-label>
                  <input matInput formControlName="unit" />
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.DDID">DDID</mat-label>
                  <input matInput formControlName="ddid" />
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.NDC">NDC</mat-label>
                  <input matInput formControlName="ndc" />
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.UPC_CODE">UPC Code</mat-label>
                  <input matInput formControlName="upc_code" />
                </mat-form-field>
              </div>
              <div class="col-lg-4">
                <kt-general-autocomplete
                  [label]="'Drug Group'"
                  [loadItemsFunction]="drugGroupAutocompleteCall"
                  [optionFormatter]="filterDrugGroupFn"
                  [valueFormatter]="filterDrugGroupFn"
                  [readOnly]="view"
                  [control]="drugForm.get('drug_group')"
                  [change]="onDrugGroupChange.bind(this)"
                  [dataPath]="'data'"
                  [placeholder]="'Select Drug Group'"
                  #drugGroupAutocomplete
                ></kt-general-autocomplete>
              </div>

              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.DRUG_SCHEDULE">Drug Schedule</mat-label>
                  <mat-select formControlName="drug_schedule">
                    <mat-option value="0">0</mat-option>
                    <mat-option value="2">2</mat-option>
                    <mat-option value="3">3</mat-option>
                    <mat-option value="4">4</mat-option>
                    <mat-option value="5">5</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.GENERIC">Generic</mat-label>
                  <input matInput formControlName="generic" />
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.PACK_SIZE">Pack Size</mat-label>
                  <input matInput formControlName="pack_size" />
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.MANUFACTURER">Manufacturer</mat-label>
                  <input matInput formControlName="manufacturer" />
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.TH_CLASS">Therapeutic Class</mat-label>
                  <input matInput formControlName="th_class" />
                </mat-form-field>
              </div>
              <div class="col-lg-3 kt-margin-bottom-20-mobile">
                <div class="mat-form-field-fluid">
                  <mat-label class="row ml-1" translate="DRUG.FORM.STATUS">Drug Status</mat-label>
                  <mat-slide-toggle class="mr-2" formControlName="is_active"></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>{{ getStatusString() }}</strong>
                  </mat-hint>
                </div>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mt-10 mb-6">Identifiers</h5>
            </div>
            <div class="form-group row" [formGroup]="drugForm">
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.CFI">CFI</mat-label>
                  <input matInput formControlName="cfi" />
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.HICL_SEQNO">HICL Seq No</mat-label>
                  <input matInput formControlName="hicl_seqno" />
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.JCODE">J-Code Assistance URL</mat-label>
                  <input matInput formControlName="jcode" />
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.GPI">GPI</mat-label>
                  <input matInput formControlName="gpi" />
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.RXCUI">RXCUI</mat-label>
                  <input matInput formControlName="rxcui" />
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mt-10 mb-6">Other</h5>
            </div>
            <div class="form-group row" [formGroup]="drugForm">
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="DRUG.FORM.NOTE">Note</mat-label>
                  <textarea matInput rows="7" formControlName="note" maxlength="1000"></textarea>
                  <mat-hint align="end">{{ drugForm.get('note').value?.length || 0 }}/1000</mat-hint>
                  <mat-error *ngIf="isControlHasError('note', 'maxlength')">
                    Maximum length is 1000 characters
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <!--end::Body-->
        </form>
        <!--end::Form-->
      </div>
    </div>
    <!--end::Content-->
  </div>
  <!--end::Profile Personal Information-->
</div>
<!--end::Container-->
